import { Pipe, PipeTransform } from '@angular/core';

import { ScannersEndpoints } from '../../../core/models';

@Pipe({
  name: 'geoedgeFilter',
  standalone: false
})
export class GeoedgeFilterPipe implements PipeTransform {
  transform(companies: ScannersEndpoints.IGeoEdgeSSPCompany[], search: string, type: string, activity: number): any[] {
    if (activity > -1 && companies) {
      const filteredByEndpoint = companies.filter(company => {
        const side = type + '_settings';
        let hasEndpoint = false;
        const endp: any[] = [];

        for (const indx in company[side]) {
          if ((company[side as keyof object][indx] as { active: number }).active === activity) {
            hasEndpoint = true;
            endp.push(company[side][indx]);
            return false;
            return filteredByEndpoint;
          }
        }

        company[type + '_settings'] = endp;

        if (hasEndpoint) {
          return true;
        }
        return false; // Ensure the filter function always returns a boolean
      });
    }

    if (!search || typeof search !== 'string' || search.length < 2) {
      return companies;
    }

    search = search.toLowerCase();

    // let endpointFilterParam = (type == 'ssp' ? 'name' : 'endpoint');
    const filteredCompanies = companies.filter(company => {
      return ~company.name.toLowerCase().indexOf(search);
    });

    if (filteredCompanies.length) {
      return filteredCompanies;
    }

    const filteredByEndpoint = companies.filter(company => {
      const hasEndpoint = company[type + '_settings'].find((endpoint: { [x: string]: string; id: any; }) => {
        return (endpoint.name.toLowerCase().includes(search)) || (endpoint.geoedge_key?.toLowerCase().includes(search))
          || (endpoint.id.toString().includes(search));
      });

      return !!hasEndpoint;
    });

    if (!filteredByEndpoint.length) {
      if (filteredCompanies.length) {
        return filteredCompanies;
      }
      return [];
    }

    const final = filteredByEndpoint.map((company) => {
      const filteredEndpoints = company[type + '_settings'].filter((endpoint: { [x: string]: string; id: any; }) => {
        return (endpoint.name.toLowerCase().includes(search)) || (endpoint.geoedge_key?.toLowerCase().includes(search))
          || (endpoint.id.toString().includes(search));
      });
      const newComp = { ...company };
      newComp[type + '_settings'] = filteredEndpoints;
      return newComp;
    });



    return final;
  }
}
